import { render, staticRenderFns } from "./DeferredJobReport.vue?vue&type=template&id=8b9f7270&scoped=true"
import script from "./DeferredJobReport.vue?vue&type=script&lang=js"
export * from "./DeferredJobReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9f7270",
  null
  
)

export default component.exports